import { getTenantId } from '../util';
import { createAxiosAuthInstance } from './api';
import UserService from './keycloak';
import { getStrategyType } from '../util/localStorageUtils';

//dummy auth platform
const axios = createAxiosAuthInstance();

const UI_CATEGORY = 'UICategory';

export async function postLogin(payload) {
  const { username, password } = payload;

  const convertedCredentials = window.btoa(`${username}:${password}`);

  const headers = {};

  return await axios
    .post(
      `/users/login`,
      { credentials: convertedCredentials, tenantId: getTenantId() },
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        if (err.response.status === 401) {
          throw {
            status: err.response.status,
            error: "Either user doesn't exists or wrong password"
          };
        }

        if (err.response.status === 504) {
          throw {
            status: err.response.status,
            error: 'Your connection has timed out. Please try again later.'
          };
        }

        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function postLoginKeycloak() {
  if (!UserService.isAuthenticated()) {
    // If not authenticated, redirect to the Keycloak login page
    UserService.doLogin();
  }
}

export async function fetchUsersModules() {
  const headers = {};
  return await axios
    .get(`/users/modules`, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function fetchResources(applicationId, roleCode) {
  const headers = {};
  const params = {
    category: UI_CATEGORY,
    applicationId: applicationId,
    roleCode
  };

  return await axios
    .get(`/resources`, { headers, params })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function putChangePassword(payload) {
  const { username, password, newPassword, userId } = payload;

  const convertedCredentials = window.btoa(`${username}:${password}`);
  const headers = {
    Authorization: `Basic ${convertedCredentials}`
  };

  const apiPayload = {
    newPassword: window.btoa(newPassword),
    oldPassword: window.btoa(password),
    userId
  };

  return await axios
    .put(`/users/changePassword`, apiPayload, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function putChangeDefaultRole(
  token,
  roleCode,
  moduleCode,
  isDefault
) {
  const headers = {
    Authorization: token
  };

  const apiPayload = {
    roleCode,
    moduleCode,
    isDefault
  };

  return await axios
    .put(`/users/default`, apiPayload, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) {
        throw {
          status: err.response.status,
          error: err.response.data
        };
      } else {
        throw {
          status: 401,
          error: err.message
        };
      }
    });
}

export async function postLogout({ payload }) {
  const { token } = payload;
  const headers = {};
  const strategyType = getStrategyType() || '';
  if (strategyType?.toLowerCase() === 'keycloak') {
    UserService.doLogout();
    return;
  }
  return await axios.delete(`/users/logout?token=${token}`, { headers });
}

